import axiosFetch from './config';

export const getBalance = async () => {
  return axiosFetch({
    method: 'GET',
    url: `/balance?currencyId=484`,
    headers: {
      Authorization: localStorage.getItem("token")
    },
  })
}